/* RESPONSIBLE TEAM: team-knowledge-foundations */
export enum Status {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  NotApplicable = 3,
}
